const CMS_BLOCK_MAP = {
  "poker-promo.intro-text": "IntroText",
  "poker-promo.periods": "Periods",
  "poker-promo.cash-games-info": "CashGamesInfo",
  "poker-promo.rules": "Rules",
};

const DEFAULT_THEME = {
  highlightColor: "var(--red)",
  bonusTextColor: "#fff",
  heroTitleFullWidth: false,
  payoutIsMarkdown: false,
  includeIntro2: false,
};

const normalizeSectionShape = (section) => {
  if (!section) {
    return null;
  }

  if (section.type) {
    return {
      type: section.type,
      props: section.props || {},
    };
  }

  if (section.__component) {
    const mappedType = CMS_BLOCK_MAP[section.__component];

    if (!mappedType) {
      return null;
    }

    const { __component, id, ...props } = section;
    return {
      type: mappedType,
      props,
    };
  }

  return null;
};

const normalizeSections = (sections = []) =>
  sections.map((section) => normalizeSectionShape(section)).filter(Boolean);

const buildLegacySections = ({ content, includeIntro2 }) => {
  const sections = [
    {
      type: "IntroText",
      props: {
        content: content?.content?.intro1,
      },
    },
  ];

  if (includeIntro2 && content?.content?.intro2) {
    sections.push({
      type: "IntroText",
      props: {
        content: content.content.intro2,
      },
    });
  }

  sections.push(
    {
      type: "Periods",
      props: {
        qualifyingPeriods: content?.content?.qualifyingPeriods,
        payoutPeriods: content?.content?.payoutPeriods,
      },
    },
    {
      type: "CashGamesInfo",
      props: {},
    },
    {
      type: "Rules",
      props: {
        title: content?.content?.rules?.title,
        content: content?.content?.rules?.content,
      },
    }
  );

  return sections;
};

/**
 * Merges JSON-driven page config with optional JSX prop overrides (migration).
 * Priority per field: JSON value → JSX prop → default.
 */
const resolvePageConfig = (content, propOverrides = {}) => {
  const jsonTheme = content?.theme || {};
  const jsonAssets = content?.assets || {};

  const pick = (jsonValue, propValue, defaultValue) => {
    if (jsonValue !== undefined && jsonValue !== null) {
      return jsonValue;
    }
    if (propValue !== undefined && propValue !== null) {
      return propValue;
    }
    return defaultValue;
  };

  return {
    scheduleKeyName: content?.scheduleKeyName || propOverrides.scheduleKeyName,
    heroBgImage: jsonAssets.heroBgImage || propOverrides.heroBgImage,
    heroImage: jsonAssets.heroImage || propOverrides.heroImage,
    heroImageAlt: jsonAssets.heroImageAlt || propOverrides.heroImageAlt,
    highlightColor: pick(
      jsonTheme.highlightColor,
      propOverrides.highlightColor,
      DEFAULT_THEME.highlightColor
    ),
    bonusTextColor: pick(
      jsonTheme.bonusTextColor,
      propOverrides.bonusTextColor,
      DEFAULT_THEME.bonusTextColor
    ),
    heroTitleFullWidth: pick(
      jsonTheme.heroTitleFullWidth,
      propOverrides.heroTitleFullWidth,
      DEFAULT_THEME.heroTitleFullWidth
    ),
    payoutIsMarkdown: pick(
      jsonTheme.payoutIsMarkdown,
      propOverrides.payoutIsMarkdown,
      DEFAULT_THEME.payoutIsMarkdown
    ),
    includeIntro2: pick(
      jsonTheme.includeIntro2,
      propOverrides.includeIntro2,
      DEFAULT_THEME.includeIntro2
    ),
    joinUsDateKey: content?.joinUsDateKey || propOverrides.joinUsDateKey,
  };
};

const resolveHeroImage = (heroImage, language) => {
  if (!heroImage) {
    return "";
  }

  return heroImage.replace("{lang}", language).replace("{lng}", language);
};

export {
  CMS_BLOCK_MAP,
  buildLegacySections,
  normalizeSections,
  resolvePageConfig,
  resolveHeroImage,
};
